<script setup>
import FilterSvg from "@/components/UI/svg/FilterSvg.vue";
import {ref, defineModel, computed, defineProps, defineEmits} from "vue";
import FilterProcessorUpdate from "@/components/Connection/FilterProcessorUpdate.vue";
import CrossCloseNotifySvg from "@/components/UI/svg/CrossCloseNotifySvg.vue";


const isToggle = defineModel()

const conditions = defineModel('conditions')
const conditionType = defineModel('conditionType')
const spreadsheetId = defineModel("spreadsheetId")
const tabId = defineModel("tabId")

const emits = defineEmits(['change-step', 'next-step'])

const props = defineProps({
    isManyTables: {
        isRequired: true,
        type: Boolean,
    }
})

const conditionTypes = ref([
    {
        name: 'Данные соответсвует нескольким условиям одновременно (AND)',
        type: 'AND'
    },
    {
        name: 'Данные соответсвует одному из услоовий (OR)',
        type: 'OR'
    }
])



const conditionTypeValue = computed({
    get: () => conditionTypes.value.find(item => item.type === conditionType.value),
    set: (newItem) => {
        if (newItem === "OR" || newItem === "AND") {
            conditionType.value = conditionTypes.value.find(item => item.type === newItem).type;
        }
        else {
            conditionType.value = conditionTypes.value.find(item => item.type === newItem.type).type;
        }
    }
});



function toggleBlock() {
    isToggle.value = false
}

function changeStep() {
    emits('change-step')
}

function nextStep() {
    emits('next-step')
}

</script>

<template>
    <div class="relative">
        <div
            v-show="isToggle"
            v-on:click="toggleBlock"
            class="w-full bg-white rounded-lg h-32 flex items-center justify-start shadow-xl border-2 border-transparent cursor-pointer hover:border-blue-500"
        >
            <div class="w-full flex items-center justify-between h-32">
                <div class="flex items-center justify-center">
                    <FilterSvg class="w-20 ml-5 mr-2" />
                    <div>
                        <div class="font-bold text-xl">
                            Фильтр
                        </div>
                        <div>
                            Условие
                        </div>
                    </div>
                </div>
                <div
                    class="mr-10 size-10 flex items-center justify-center rounded-full hover:bg-gray-200 cursor-pointer transition-all duration-150"
                    v-on:click="changeStep"
                >
                    <CrossCloseNotifySvg class="size-8"/>
                </div>
            </div>
        </div>
        <div
            v-show="!isToggle"
            class="w-full flex flex-col justify-center items-start bg-white rounded-lg shadow-xl"
        >
            <div class="w-full flex items-center justify-between h-32">
                <div class="flex items-center justify-center">
                    <FilterSvg class="w-20 ml-5 mr-2" />
                    <div>
                        <div class="font-bold text-xl">
                            Фильтр
                        </div>
                        <div>
                            Условие
                        </div>
                    </div>
                </div>
                <div
                    class="mr-10 size-10 flex items-center justify-center rounded-full hover:bg-gray-200 cursor-pointer transition-all duration-150"
                    v-on:click="changeStep"
                >
                    <CrossCloseNotifySvg class="size-8"/>
                </div>
            </div>
            <FilterProcessorUpdate
                v-model:conditions="conditions"
                v-model:condition-type="conditionTypeValue"
                v-model:spreadsheet-id="spreadsheetId"
                v-model:tab-id="tabId"
                :header-index="1"
                :condition-types="conditionTypes"
                :is-many-tables="props.isManyTables"
            />
        </div>
        <div
            class="fixed left-1/2 -translate-x-1/2 sm:left-auto sm:right-4 md:right-6 lg:right-10 bottom-4 sm:bottom-5 px-5 py-3 rounded-full bg-blue-500 hover:bg-blue-600 duration-150 transition-all cursor-pointer select-none font-bold text-white z-30"
            v-on:click="nextStep"
        >
            Следующий шаг
        </div>
    </div>

</template>

<style scoped>

</style>